// extracted by mini-css-extract-plugin
export var deliveryRow = "_s5-a";
export var fixedHeight = "_s5-4";
export var freightLogo = "_s5-9";
export var fullWidth = "_s5-3";
export var priceColumn = "_s5-5";
export var radioSelected = "_s5-7";
export var radioUnselected = "_s5-6";
export var selectedOption = "_s5-2";
export var selectedOptionContainer = "_s5-1";
export var selection = "_s5-0";
export var tallSkeletonText = "_s5-8";